import { action, actionBound, observable } from 'mobx';
import { TBrand, TTheme } from '@teliaee/design-system';

class Config {
  @observable accessor eidAuthDomain: string = '';
  @observable accessor teliaWebUrl: string = '';
  @observable accessor selfServiceUrl: string = '';
  @observable accessor diilSelfServiceUrl: string = '';
  @observable accessor superUrl: string = '';
  @observable accessor env: string = '';
  @observable accessor apiUrl: string = '';
  @observable accessor frontendUrl: string = '';
  @observable accessor isModule: boolean = false;
  @observable accessor brand: TBrand | null = null;
  @observable accessor theme: TTheme | null = null;
  public initialized: boolean = false;

  @actionBound
  public initialize(initialConfig: InitialConfig) {
    this.eidAuthDomain = initialConfig.eidAuthDomain;
    this.teliaWebUrl = initialConfig.teliaWebUrl;
    this.selfServiceUrl = initialConfig.selfServiceUrl;
    this.diilSelfServiceUrl = initialConfig.diilSelfServiceUrl;
    this.superUrl = initialConfig.superUrl;
    this.env = initialConfig.env;
    this.initialized = true;
  }

  @actionBound
  public setFrontendUrl(feUrl: string) {
    this.frontendUrl = feUrl;
  }

  @actionBound
  public setApiUrl(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  @actionBound
  public setIsModule(isModule: boolean) {
    this.isModule = isModule;
  }

  @actionBound
  public setBrand(brand: string) {
    this.brand = brand as TBrand | null;
  }

  @actionBound
  public setTheme(theme: string) {
    this.theme = theme as TTheme | null;
  }
}

export default new Config();
